module.exports = __webpack_public_path__ + "assets/img/resources.15520a4b.svg";